function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "school bus 02");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M451.5,95.274A23.531,23.531,0,0,0,428,118.8v59.214a23.459,23.459,0,0,0,10.805,19.822L416,225.073V80.1C416,50.471,391.936,26,362.31,26H148.523C118.9,26,95,50.471,95,80.1V224.867L72.623,198.246A23.4,23.4,0,0,0,84,178.016V118.8a23.5,23.5,0,1,0-47,0v59.214a23.586,23.586,0,0,0,19.814,23.227l29.414,35.225C66.184,244.27,52,263.293,52,285.481V400.5a30.659,30.659,0,0,0,29,30.346v38.62C81,486.9,94.8,502,111.139,502h11.682C139.18,502,153,486.9,153,469.462V431H359v38.462C359,486.9,372.82,502,389.179,502h11.682C417.2,502,431,486.9,431,469.462V430.806a30.2,30.2,0,0,0,28-30.31v-38.83a7.063,7.063,0,0,0,0-1.883v-74.3a52.181,52.181,0,0,0-34-49.3l29.06-34.784A23.582,23.582,0,0,0,475,178.016V118.8A23.531,23.531,0,0,0,451.5,95.274ZM174.144,241.856C177.21,219.7,197.946,202,220.368,202h71.264c22.422,0,43.158,17.7,46.224,39.856L353.848,357H158.136ZM350.245,233c-7.036-26-31.9-45-58.613-45H220.368c-26.715,0-51.577,19-58.612,45H109V93H402V233ZM148.523,40H362.31c21.573,0,39.172,18,39.7,39h-293.2C109.35,58,126.95,40,148.523,40ZM51,178.016V118.8a9.5,9.5,0,1,1,19,0v59.214a9.5,9.5,0,1,1-19,0ZM66,285.481C66,264.085,84.153,247,106.466,247h52.851L144,357H66Zm73,183.981c0,9.68-7.56,18.538-16.179,18.538H111.139C102.542,488,95,479.142,95,469.462V431h44ZM400.861,488H389.179C380.56,488,373,479.142,373,469.462V431h44v38.462C417,479.142,409.459,488,400.861,488Zm28.01-71H82.657A16.735,16.735,0,0,1,66,400.5V371H445v29.5A16.284,16.284,0,0,1,428.871,417ZM445,285.481V357H367.981l-15.3-110h52.852C427.665,247,445,263.723,445,285.481Zm16-107.465a9.5,9.5,0,1,1-19,0V118.8a9.5,9.5,0,1,1,19,0Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201,255H311a7,7,0,0,0,0-14H201a7,7,0,0,0,0,14Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201,294H311a7,7,0,0,0,0-14H201a7,7,0,0,0,0,14Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M201,333H311a7,7,0,0,0,0-14H201a7,7,0,0,0,0,14Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M108.5,279.609A29.585,29.585,0,1,0,138,309.193,29.576,29.576,0,0,0,108.5,279.609Zm0,45.169A15.585,15.585,0,1,1,124,309.193,15.56,15.56,0,0,1,108.5,324.778Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M374,309.193a29.5,29.5,0,1,0,29.5-29.584A29.575,29.575,0,0,0,374,309.193Zm45,0a15.5,15.5,0,1,1-15.5-15.584A15.56,15.56,0,0,1,419,309.193Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default __webpack_public_path__ + "static/media/school-bus.fb2cde47.svg";
export { SvgComponent as ReactComponent };